import React from 'react'
import { AvatarGroup, Avatar, Box, Typography, useTheme } from '@mui/material'
import { User } from 'types'

interface StaticApproverDisplayProps {
  label: string
  approverIds: string[]
  users: User[]
}

const StaticApproverDisplay: React.FC<StaticApproverDisplayProps> = ({ label, approverIds, users }) => {
  const theme = useTheme()
  const approvers = users.filter(user => approverIds.includes(user.user_uuid))
  //   console.log('approverIds', approverIds)
  //   console.log('approvers', approvers)

  return (
    <Box>
      <Typography textAlign={'left'} fontWeight={600} gutterBottom>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <AvatarGroup
          max={5}
          spacing={'medium'}
          slotProps={{
            additionalAvatar: {
              sx: {
                height: 36,
                width: 36,
                fontSize: 13,
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
              },
            },
          }}
        >
          {approvers.map(user => (
            <Avatar key={user.user_uuid} alt={user.name} src={user.image_512} />
          ))}
        </AvatarGroup>
      </Box>
    </Box>
  )
}

export default StaticApproverDisplay
